import { render, staticRenderFns } from "./form-mobile.vue?vue&type=template&id=3d65ab80&scoped=true"
import script from "./form-mobile.vue?vue&type=script&lang=ts"
export * from "./form-mobile.vue?vue&type=script&lang=ts"
import style0 from "./form-mobile.vue?vue&type=style&index=0&id=3d65ab80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d65ab80",
  null
  
)

export default component.exports